import {tableURLStateSchema} from "@project/components/data-display/table";
import type {materialNotesRouteApi} from "./-route-api";
import {z} from "zod";

export const materialNotesSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type MaterialNotesSearch = z.infer<typeof materialNotesSearchSchema>;
export type MaterialNotesNavigateFn = ReturnType<typeof materialNotesRouteApi.useNavigate>;
